<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div style="text-align: center; margin-bottom: 20px;">
      <span>确定删除店铺通知</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteStoreMsg">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopMsg } from '@/api/storeMsgApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteStoreMsg',
  data() {
    return {
      dialogVisible: false,
      deleteData: {}
    }
  },
  methods: {
    open(row) {
      this.deleteData = { ...row }
      this.dialogVisible = true
    },
    async deleteStoreMsg() {
      try {
        this.deleteData.shopId = getShopId()
        
        const res = await deleteShopMsg(this.deleteData)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        }
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>